import { type FC, type ReactNode } from 'react';
import { AppShellManager } from 'src/components/layout/app-shell/app-shell-manager';
import { ContextualSidebar } from 'src/components/layout/app-shell/contextual-sidebar';
import { Sidebar } from 'src/components/layout/app-shell/sidebar';
import { AppShellSkeleton } from 'src/components/layout/app-shell/skeleton';
import { useAppShellData } from 'src/components/layout/app-shell/use-app-shell-data';
import { useAppShell } from 'src/components/layout/app-shell/use-app-shell-provider';

type AppShellProps = {
  children: ReactNode;
};

export const AppShell: FC<AppShellProps> = ({ children }) => {
  const appShellData = useAppShellData();
  const { contextualSidebarPortal } = useAppShell();

  if (!appShellData) return <AppShellSkeleton>{children}</AppShellSkeleton>;

  return (
    <AppShellManager
      contextualSidebarTargetRef={contextualSidebarPortal.targetRef}
      sidebar={(props) => <Sidebar appShellData={appShellData} {...props} />}
      contextualSidebar={
        <ContextualSidebar>{contextualSidebarPortal.target}</ContextualSidebar>
      }
    >
      {children}
    </AppShellManager>
  );
};
